import configuration from './configuration';

const config = typeof window === 'undefined' ? configuration : (window as any).__STL_C__ || configuration;

export default config;
